class Component {
  init() {
    this.iframes = document.querySelectorAll('iframe[src*="vimeo.com"]')
    if (!this.iframes.length) return

    this.readyIframes = new Set()
    this.pendingCommands = new Map()
    this.messageHandler = this.handleMessage.bind(this)

    window.addEventListener('message', this.messageHandler)

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const method = entry.isIntersecting ? 'play' : 'pause'
        this.sendCommand(entry.target, method)
      })
    }, {
      threshold: 0.3,
      rootMargin: '50px 0px'
    })

    this.iframes.forEach(iframe => {
      const onReady = () => {
        this.readyIframes.add(iframe)
        const pending = this.pendingCommands.get(iframe)
        if (pending) {
          this.postMessage(iframe, pending)
          this.pendingCommands.delete(iframe)
        }
      }

      iframe.addEventListener('load', onReady)

      try {
        if (iframe.contentDocument?.readyState === 'complete') {
          onReady()
        }
      } catch {
        // Cross-origin iframe — wait for load event or Vimeo ready message
      }

      this.observer.observe(iframe)
    })
  }

  handleMessage(event) {
    if (event.origin !== 'https://player.vimeo.com') return

    try {
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data
      if (data.event === 'ready') {
        this.iframes.forEach(iframe => {
          if (iframe.contentWindow === event.source) {
            this.readyIframes.add(iframe)
          }
        })
      }
    } catch {
      // Ignore non-JSON messages
    }
  }

  sendCommand(iframe, method) {
    if (this.readyIframes.has(iframe)) {
      this.postMessage(iframe, method)
    } else {
      this.pendingCommands.set(iframe, method)
    }
  }

  postMessage(iframe, method) {
    iframe.contentWindow.postMessage(JSON.stringify({ method }), 'https://player.vimeo.com')
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
    window.removeEventListener('message', this.messageHandler)
  }
}

export default new Component()
